export const entertainmentActionTypes = {
  SELECT_EVENT: "SELECT_EVENT",
  SELECT_EVENT_2: "SELECT_EVENT_2",
  SELECT_EVENT_TOGGLE: "SELECT_EVENT_TOGGLE",
  READ_MORE: "READ_MORE",
};
